<div class="modal-header">
    <h5 class="modal-title">{{data.studentName}} </h5>
    <button type="button" class="close"  mat-dialog-close>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

<div class=" question-card">
        <div class="row">

            <div class="col-xl-6 col-md-6">
                <div class="question-data card">
                        <p class="">{{'general.College' | translate}}</p>
                        <h2 class="mb-0" > {{student.faculty}} </h2>
                </div>
            </div>

            <div class="col-xl-6 col-md-6">
                <div class="question-data card">
                    <p class=" ">{{'general.program' | translate}}</p>
                    <h2 class="mb-0" > {{student.program}} </h2>
                </div>
            </div>

            <div class="col-xl-6 col-md-6">
                <div class="question-data card">
                     <p class=" ">{{'general.branch' | translate}}</p>
                      <h2 class="mb-0" >{{student.branch}}</h2>
                </div>
            </div>

              <div class="col-xl-6 col-md-6 ">
                <div class="question-data card">
                     <p class="">{{'general.groups' | translate}}</p>
                     <h2 class="mb-0" *ngFor="let section of student.crNs">{{section}}</h2>
                    </div>
                </div>

            </div>

    </div>

  <div class="row">
    <div class="col-12">
    <button type="submit" class="btn-add btn-block" mat-dialog-close>{{'general.cancel' | translate}}</button>
    </div>
    </div>

</div>
